<template>
	<div class="border-top">
		<SOFilterTitle :title="'Status Transaksi'" :diterapkan="diterapkan" :id="id"/>
		<SOFilterCheckboxSkeleton v-if="pageSetting.loading"/>
		<div class="p-l-24 p-r-24 p-d-24" v-show="false" :id="id" v-if="!pageSetting.loading">
			<SOInputCheckbox
				:checkboxes="jenisTransaksi"
				@selected="selected"
				@selected-child="selectedChild"
				:checked="filterItem.jenisTransaksiRiwayatTransfer"
				:checked-child="selectedChildData"
			/>
		</div>
	</div>
</template>

<script>
import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOFilterCheckboxSkeleton from "@/so-components/global/filter/skeleton/SOFilterCheckboxSkeleton";
import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox";
import {mapGetters} from "vuex";

export default {
	name: "SOFilterJenisTransaksiRiwayatTransfer",
	components: {
		SOFilterTitle,
		SOFilterCheckboxSkeleton,
		SOInputCheckbox,
	},
	props: {
		id: String,
	},
	computed: {
		...mapGetters("filterGlobalModule", {
			filterItem: "getFilterItem"
		})
	},
	data() {
		return {
			jenisTransaksi: {
				name: "jenis-transaksi",
				data: [
					{
						id: "jt-1",
						value: "uang_masuk",
						title: "Uang Masuk",
						checked: false,
						titleBold: false,
						child: {
							name: "uang_masuk",
							data: [
								{
									id: "uang_masuk1",
									value: "pembayaran_transaksi",
									title: "Pembayaran transaksi",
									checked: false,
									titleBold: false,
								},
								{
									id: "uang_masuk2",
									value: "transfer_masuk",
									title: "Transfer masuk",
									checked: false,
									titleBold: false,
								},
								{
									id: "uang_masuk3",
									value: "settlement_edc",
									title: "Settlement EDC",
									checked: false,
									titleBold: false,
								},
								{
									id: "uang_masuk4",
									value: "entry_manual_masuk",
									title: "Entry manual",
									checked: false,
									titleBold: false,
								},
							]
						}
					},
					{
						id: "jt-2",
						value: "uang_keluar",
						title: "Uang Keluar",
						checked: false,
						titleBold: false,
						child: {
							name: "uang_keluar",
							data: [
								{
									id: "uang_keluar1",
									value: "refund_transaksi",
									title: "Refund transaksi",
									checked: false,
									titleBold: false,
								},
								{
									id: "uang_keluar2",
									value: "transfer_keluar",
									title: "Transfer keluar",
									checked: false,
									titleBold: false,
								},
								{
									id: "uang_keluar3",
									value: "pengeluaran_biaya",
									title: "Pengeluaran biaya",
									checked: false,
									titleBold: false,
								},
								{
									id: "uang_keluar4",
									value: "entry_manual_keluar",
									title: "Entry manual",
									checked: false,
									titleBold: false,
								},
							]
						}
					},
				]
			},
			pageSetting: {
				loading: false,
			},
			selectedChildData: [],
			diterapkan: false,
		}
	},
	mounted() {
		this.selectedChildData = [...this.filterItem.uangMasukRiwayatTransfer, ...this.filterItem.uangKeluarRiwayatTransfer]
		if (this.filterItem.uangMasukRiwayatTransfer.length > 0) {
			if (this.filterItem.jenisTransaksiRiwayatTransfer.length === 0) {
				this.filterItem.jenisTransaksiRiwayatTransfer = [...this.filterItem.jenisTransaksiRiwayatTransfer, "uang_masuk"]
			} else {
				if (!this.filterItem.jenisTransaksiRiwayatTransfer.includes("uang_masuk")) {
					this.filterItem.jenisTransaksiRiwayatTransfer = [...this.filterItem.jenisTransaksiRiwayatTransfer, "uang_masuk"]
				}
			}
		}
		if (this.filterItem.uangKeluarRiwayatTransfer.length > 0) {
			if (this.filterItem.jenisTransaksiRiwayatTransfer.length === 0) {
				this.filterItem.jenisTransaksiRiwayatTransfer = [...this.filterItem.jenisTransaksiRiwayatTransfer, "uang_keluar"]
			} else {
				if (!this.filterItem.jenisTransaksiRiwayatTransfer.includes("uang_keluar")) {
					this.filterItem.jenisTransaksiRiwayatTransfer = [...this.filterItem.jenisTransaksiRiwayatTransfer, "uang_keluar"]
				}
			}
		}
		this.diterapkan = this.selectedChildData.length > 0
	},
	methods: {
		selected(val) {
			let temp = this.filterItem
			temp.jenisTransaksiRiwayatTransfer = val
			this.diterapkan = this.filterItem.jenisTransaksiRiwayatTransfer.length > 0
			if (!temp.jenisTransaksiRiwayatTransfer.includes("uang_masuk")) {
				temp.uangMasukRiwayatTransfer = []
				setTimeout(() => {
					$("input[name=uang_masuk]").prop("checked", false)
				}, 100)
			}
			if (!temp.jenisTransaksiRiwayatTransfer.includes("uang_keluar")) {
				temp.uangKeluarRiwayatTransfer = []
				setTimeout(() => {
					$("input[name=uang_keluar]").prop("checked", false)
				}, 100)
			}
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
		},
		selectedChild(val) {
			let temp = this.filterItem
			temp.uangMasukRiwayatTransfer = []
			temp.uangKeluarRiwayatTransfer = []
			// console.log("test", this.jenisTransaksi.data[0].child.data.filter(v => val.includes(v.value) === true))
			let uangMasukArr = this.jenisTransaksi.data[0].child.data.filter(v => val.includes(v.value) === true)
			let uangKeluarArr = this.jenisTransaksi.data[1].child.data.filter(v => val.includes(v.value) === true)
			if (temp.jenisTransaksiRiwayatTransfer.includes("uang_masuk")) {
				if (uangMasukArr.length > 0) {
					uangMasukArr.forEach(v => {
						temp.uangMasukRiwayatTransfer = [...temp.uangMasukRiwayatTransfer, v.value]
					})
				}
			}
			if (temp.jenisTransaksiRiwayatTransfer.includes("uang_keluar")) {
				if (uangKeluarArr.length > 0) {
					uangKeluarArr.forEach(v => {
						temp.uangKeluarRiwayatTransfer = [...temp.uangKeluarRiwayatTransfer, v.value]
					})
				}
			}
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
		},
	}
}
</script>